export const CONFIG_KEY_GET_CONFIGURATION_TYPE = 'CONFIG_KEY_GET_CONFIGURATION_TYPE';
export const CONFIG_KEY_POST_CONFIGURATION_TYPE = 'CONFIG_KEY_POST_CONFIGURATION_TYPE';
export const CONFIG_KEY_POST_OPEN_PERIOD_CONFIG = 'CONFIG_KEY_POST_OPEN_PERIOD_CONFIG';
export const CONFIG_KEY_PUT_OPEN_PERIOD_CONFIG = 'CONFIG_KEY_PUT_OPEN_PERIOD_CONFIG';
export const CONFIG_KEY_POST_CHECK_OPEN_PERIOD_CONFIG = 'CONFIG_KEY_POST_CHECK_OPEN_PERIOD_CONFIG';